"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEmployeesByFilterOptions = exports.UpdateEmployeeDto = exports.CreateEmployeeOptions = exports.CreateEmployeeDto = exports.BuildEmployee = exports.EmployeeWithRoleIds = exports.EmployeeWithRoles = exports.EmployeeDto = exports.ByEmployeeIdDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
class ByEmployeeIdDto {
}
exports.ByEmployeeIdDto = ByEmployeeIdDto;
class EmployeeDto {
}
exports.EmployeeDto = EmployeeDto;
class EmployeeWithRoles extends EmployeeDto {
}
exports.EmployeeWithRoles = EmployeeWithRoles;
class EmployeeWithRoleIds extends EmployeeWithRoles {
}
exports.EmployeeWithRoleIds = EmployeeWithRoleIds;
class BuildEmployee {
}
exports.BuildEmployee = BuildEmployee;
class CreateEmployeeDto {
}
exports.CreateEmployeeDto = CreateEmployeeDto;
class CreateEmployeeOptions {
}
exports.CreateEmployeeOptions = CreateEmployeeOptions;
// TODO: Update with the correct fields
class UpdateEmployeeDto {
}
exports.UpdateEmployeeDto = UpdateEmployeeDto;
class GetEmployeesByFilterOptions extends general_dto_1.PaginationQuery {
    constructor() {
        super(...arguments);
        this.includeRoles = true;
    }
}
exports.GetEmployeesByFilterOptions = GetEmployeesByFilterOptions;
//# sourceMappingURL=employee.dto.js.map